import { FC } from 'react';
import { TableMemberStatus } from '../types/members-types';
import StatusChip from './StatusChip';

const InvitationStatusChip: FC<
  React.PropsWithChildren<InvitationStatusChipProps>
> = ({ isInvitationExpired, invitationExpirationLocalTime }) => {
  const label = isInvitationExpired
    ? TableMemberStatus.Expired
    : TableMemberStatus.Pending;

  const tooltipTitle = isInvitationExpired
    ? `Invitation expired on ${invitationExpirationLocalTime}`
    : `Pending acceptance, expires on ${invitationExpirationLocalTime}`;

  const color = isInvitationExpired ? 'error' : 'warning';

  return <StatusChip label={label} tooltipTitle={tooltipTitle} color={color} />;
};

export interface InvitationStatusChipProps {
  isInvitationExpired: boolean;
  invitationExpirationLocalTime: string;
}

export default InvitationStatusChip;
